// extracted by mini-css-extract-plugin
export default {"button":"Placeholder_button__VjyUW","label":"Placeholder_label__z3RQb","buttonActive":"Placeholder_buttonActive__Gun9K","item":"Placeholder_item__jlsG1"};